module.exports = __webpack_public_path__ + "static/note-styling-do-964da1c9d21e9062b386fe1bd47bb29e.png";